type Section = "streams" | "meetings";
type State = { type: "navigating"; toSection: Section } | { type: "switching-stream"; inSection: Section };

const prefix = "fellow:";

export const mark: typeof performance.mark = name => {
	return performance.mark(prefix + name);
};

export const measure: typeof performance.measure = (name, ...args) => {
	return performance.measure(prefix + name, ...args.map(arg => arg && prefix + arg));
};

class Perf {
	private state?: State;

	private _navTo(toSection: Section) {
		this.state = { type: "navigating", toSection };
		mark(`nav-start:${toSection}`);
	}

	startNavToStreams = () => {
		this._navTo("streams");
	};

	startNavToMeetings = () => {
		this._navTo("meetings");
	};

	startSwitchingStreams = (inSection: Section) => {
		this.state = { type: "switching-stream", inSection };
		mark(`switching-stream:${inSection}`);
	};

	sidebarLoaded = () => {
		if (this.state?.type !== "navigating") return;

		const { toSection } = this.state;
		if (toSection === "meetings") {
			mark("agenda-loaded");
			measure("loading:meetings:panel", "nav-start:meetings", "agenda-loaded");
			// This is the end of the "span" for meetings. We don't automatically
			// select a stream to render, so we can't accurately measure how long it
			// takes to get to a stream beyond this point. What we do instead is
			// measure the time from clicking an agenda item to when the stream loads.
			this.state = undefined;
		} else if (toSection === "streams") {
			mark("streamspanel-loaded");
			measure("loading:streams:panel", "nav-start:streams", "streamspanel-loaded");
		}
	};

	streamLoaded = () => {
		mark("stream-loaded");
		if (!this.state) return;
		if (this.state.type === "navigating") {
			const { toSection } = this.state;
			measure(`loading:${toSection}`, `nav-start:${toSection}`, "stream-loaded");
		} else if (this.state.type === "switching-stream") {
			const { inSection } = this.state;
			measure(`switching-stream:${inSection}`, `switching-stream:${inSection}`, "stream-loaded");
		}
		this.state = undefined;
	};
}

export default new Perf();
